import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { OverlayModule, Overlay } from '@angular/cdk/overlay';
import { TranslateModule } from '@ngx-translate/core';
import { RecipeService } from 'src/_service/RecipeService';

@Component({
  selector: 'app-allergenselect',
  imports: [
    TranslateModule,
    OverlayModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AllergenselectComponent),
      multi: true
    }
  ],
  templateUrl: './allergenselect.component.html',
  styleUrl: './allergenselect.component.scss'
})
export class AllergenselectComponent implements ControlValueAccessor {
  shown = false;
  _disabled = false;

  allergens: string[] = this._recipeService.getAllergens();
  selectedAllergens: string[] = [];
  scrollStrategy = this._overlay.scrollStrategies.block();

  onChange: any = () => { };
  onTouched: any = () => { };

  constructor(
    private _recipeService: RecipeService,
    private _overlay: Overlay
  ) { }

  // ControlValueAccessor Implementation
  writeValue(value: string[] | null): void {
    this.selectedAllergens = value || [];
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this._disabled = isDisabled;
  }

  toggleDropdown() {
    if (this._disabled) return;
    if (this.shown) {
      this.closeDropdown();
    } else {
      this.openDropdown();
    }
  }

  openDropdown() {
    if (this._disabled) return;
    this.shown = true;
  }

  closeDropdown() {
    if (this.shown) {
      this.shown = false;
      this.onTouched();
    }
  }

  toggleAllergen(allergen: string) {
    if (this._disabled) return;
    
    const index = this.selectedAllergens.indexOf(allergen);
    if (index > -1) {
      this.selectedAllergens.splice(index, 1);
    } else {
      this.selectedAllergens.push(allergen);
    }
    
    this.onChange([...this.selectedAllergens]);
    this.onTouched();
  }
}
